import { render } from "./Tech.vue?vue&type=template&id=e29e86d8&scoped=true"
import script from "./Tech.vue?vue&type=script&lang=js"
export * from "./Tech.vue?vue&type=script&lang=js"

import "./Tech.vue?vue&type=style&index=0&id=e29e86d8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e29e86d8"]])

export default __exports__